// src/api/summary.js

const API_BASE = "https://4jnrm82ra1.execute-api.us-east-2.amazonaws.com/dev/summary";

export const fetchSummaryByGlueId = async (glue_id) => {
  try {
    const response = await fetch(`${API_BASE}?glue_id=${encodeURIComponent(glue_id)}`);
    if (!response.ok) throw new Error("API error");
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message || "Failed to fetch summary");
  }
};
